import { Textarea } from "@/components/ui/textarea";
import { PenLine } from "lucide-react";

interface CustomInputTabProps {
  value: string;
  onChange: (value: string) => void;
}

export function CustomInputTab({ value, onChange }: CustomInputTabProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <PenLine className="h-3.5 w-3.5" />
        <span>Paste or type custom source material for the AI to use when generating content.</span>
      </div>
      <Textarea
        placeholder="Paste article text, talking points, product details, client notes, or any context you want included in the generated post..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="min-h-[300px] text-xs leading-relaxed resize-y"
      />
      {value.length > 0 && (
        <p className="text-[10px] text-muted-foreground text-right">{value.length} characters</p>
      )}
    </div>
  );
}
